var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 189,
    viewBox: "0 0 188 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M117.697 182.903C156.031 182.903 187.107 177.444 187.107 170.71C187.107 163.975 156.031 158.516 117.697 158.516C79.3621 158.516 48.2859 163.975 48.2859 170.71C48.2859 177.444 79.3621 182.903 117.697 182.903Z",
    fill: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5972 173.676L21.125 33.2026H145.528L126.75 173.676L94.327 185.436C87.9893 187.734 81.035 187.669 74.7415 185.252L44.5972 173.676Z",
    fill: "url(#paint0_linear_802:729)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.917 40.8649H12.7362C12.1839 40.8649 11.7362 40.4171 11.7362 39.8649V3C11.7362 1.34315 13.0793 0 14.7362 0H151.917C153.574 0 154.917 1.34315 154.917 3V39.8649C154.917 40.4171 154.469 40.8649 153.917 40.8649Z",
    fill: "url(#paint1_linear_802:729)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4057 83.2567L25.8198 68.9595L34.7397 122.595L62.9726 134.298C76.5801 139.938 91.7339 140.632 105.8 136.259L133.323 127.703L140.834 68.9595L109.554 83.0242C93.3043 90.3306 74.721 90.415 58.4057 83.2567Z",
    fill: "url(#paint2_linear_802:729)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_802:729",
    x1: 136.139,
    y1: 99.6081,
    x2: 35.1998,
    y2: 101.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119189,
    stopColor: "#E3BD8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372162,
    stopColor: "#B58A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584054,
    stopColor: "#B58A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3BD8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_802:729",
    x1: 84.5001,
    y1: 0,
    x2: 84.5001,
    y2: 40.8649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAE3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_802:729",
    x1: 135.671,
    y1: 107.27,
    x2: 34.74,
    y2: 107.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488372,
    stopColor: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.089fcf45.svg";
export { ForwardRef as ReactComponent };